<template>
    <v-list-group v-model="open" color="#ffffff" class="menu-group mb-1" :class="{ 'menu-group--current': hasActiveChild }" :ripple="false">
        <template v-slot:activator>
            <v-list-item-icon class="mr-3 my-auto">
                <v-icon size="18">{{ group.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title class="menu-group__title">{{ group.name }}</v-list-item-title>
            </v-list-item-content>
        </template>

        <div class="menu-group__children">
            <template v-for="(item, index) in items">
                <div v-if="item.header" :key="`h-${index}`" class="menu-group__header">{{ item.header }}</div>
                <MenuItem v-else :key="item.route" :item="item" nested />
            </template>
        </div>
    </v-list-group>
</template>

<script>
import MenuItem from "./MenuItem.vue";

const STORAGE_KEY = "bej.menu.groups";

function readState() {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}") || {};
    } catch (error) {
        return {};
    }
}

function writeState(name, open) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readState(), [name]: open }));
    } catch (error) {
        // sem armazenamento local o menu so nao lembra o estado
    }
}

// Grupo do menu lateral com submenu. Abre sozinho quando a tela atual e de um
// dos itens e lembra se o usuario deixou aberto ou fechado. Entradas
// { header } viram subtitulos dentro do grupo.
export default {
    name: "MenuGroup",

    components: { MenuItem },

    props: {
        group: { type: Object, required: true },
        // Itens do grupo ja filtrados pela permissao do usuario.
        items: { type: Array, required: true },
    },

    data() {
        return { open: false };
    },

    computed: {
        hasActiveChild() {
            const path = this.$route.path;
            return this.items.some((item) => item.route && (path === item.route || path.startsWith(`${item.route}/`)));
        },
    },

    watch: {
        hasActiveChild(active) {
            if (active) this.open = true;
        },
        open(value) {
            writeState(this.group.name, value);
        },
    },

    created() {
        const saved = readState()[this.group.name];
        this.open = this.hasActiveChild || saved === true;
    },
};
</script>

<style lang="scss" scoped>
.menu-group ::v-deep > .v-list-group__header {
    min-height: 36px;
    height: 36px;
    padding: 0 10px;
    border-radius: 8px;

    &::before {
        border-radius: 8px;
        opacity: 0 !important;
    }

    .v-list-item__icon:first-child {
        margin-right: 12px !important;
    }

    .v-icon {
        color: rgba(255, 255, 255, 0.55) !important;
    }

    &:hover {
        background-color: rgba(255, 255, 255, 0.06);

        .v-icon,
        .menu-group__title {
            color: #ffffff !important;
        }
    }
}

// Seta de abrir/fechar
.menu-group ::v-deep > .v-list-group__header .v-list-group__header__append-icon {
    min-width: 0 !important;
    margin: 0 !important;

    .v-icon {
        font-size: 18px !important;
        color: rgba(255, 255, 255, 0.35) !important;
    }
}

.menu-group__title {
    font-size: 13.5px !important;
    font-weight: 500 !important;
    color: rgba(255, 255, 255, 0.78) !important;
}

// Grupo da tela atual: titulo e icone em branco, mesmo fechado.
.menu-group--current ::v-deep > .v-list-group__header {
    .v-list-item__icon:first-child .v-icon,
    .menu-group__title {
        color: #ffffff !important;
    }
}

// Submenu com linha-guia alinhada ao icone do grupo.
// Subtitulo dentro do grupo ({ header } no menu).
.menu-group__header {
    margin: 10px 0 2px;
    padding: 0 10px 0 12px;
    font-size: 10px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.38);

    &:first-child {
        margin-top: 2px;
    }
}

.menu-group__children {
    position: relative;
    margin: 2px 0 8px 19px;
    padding-left: 12px;
    border-left: 1px solid rgba(255, 255, 255, 0.1);
}
</style>
